import React from 'react';
import { useParams } from 'react-router-dom';
import { CATEGORIES, Category } from '../types';
import CategoryHeader from './CategoryHeader';
import TopicGrid from './TopicGrid';

export default function CategoryLayout() {
  const { categorySlug, subcategorySlug } = useParams();
  
  const category = CATEGORIES.find(c => c.slug === categorySlug);
  const subcategory = category?.subcategories?.find(s => s.slug === subcategorySlug);

  const currentCategory = subcategory || category;

  if (!currentCategory) {
    return (
      <div className="min-h-[400px] flex items-center justify-center">
        <p className="text-gray-500">Category not found</p>
      </div>
    );
  }

  return (
    <div className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <CategoryHeader category={category!} subcategory={subcategory} />
        <TopicGrid category={currentCategory} />
      </div>
    </div>
  );
}